export default {
  more: "More",
  freeUser: "Free",
  at: "AT",
  days: "days",
  serviceUnavailable: "service unavailable",
  serviceUnavailableCapitalize: "Service unavailable",
  room: "Account",
  Chief: "Head",
  Admin: "Administrator",
  Manager: "Manager",
  heading: "Don't miss messages",
  text: "Turn on notifications. The browser will ask for permission to send notifications, please allow it. Then messages from ATI will appear at the bottom of the screen, no matter what website you're on.",
  btnText: "turn on notifications",
  importantMessagesPluralize: {
    one: "important message",
    few: "important messages",
    many: "important messages",
    other: "important messages",
  },
  CoWorker: "Employee",
  score: "Balance",
  firman: "Licenses",
  paidFor: "Paid until",
  add: "Upgrade",
  extend: "Extend",
  freeAccess: "You have free access",
  licenseDescr:
    "You can view only free trucks and loads. To see everything — buy a license.",
  whatLicensed: "What else gives a license?",
  selectLicense: "Choose a license",
  settings: "Settings",
  recurrentPaymentFailed: "Autopayment failed",
  moreInfo: "More",
  pay: "Pay",
  conditions: "Terms",
  logout: "Logout",
  view: "View",
  readLater: "Read later",
  participantsSearch: "ATI.SU\xa0participants\xa0search",
  advancedSearch: "Advanced Search",
  advanced: "Advanced",
  somethingWentWrong: "Something went wrong.",
  somethingWentWrongWithoutDot: "Something went wrong",
  cannotFindFirm: "We didn't find a suitable participant.",
  byExtendedSearch: "advanced search",
  tryUsing: "Try the",
  notificationSettings: "Notification settings",
  noNewNotifications: "No new notifications",
  viewedNotifications: "Viewed notifications",
  downloadLoadsAndTrucks: "Download ATI Loads and Transport",
  receiveNotifications:
    "Get notifications about new loads to your phone or tablet",
  forAndroid: "Android",
  forIPhoneIPad: "iPhone and iPad",
  markAllAsRead: "Mark all as read",
  soundOn: "Sound on",
  soundMute: "Mute",
  loads: "Loads",
  transport: "Transport",
  // carriers: "Carriers",
  checks: "Verifications",
  tenders: "Tenders",
  news: "News",
  forums: "Forums",
  docs: "Docs",
  atiDocs: "ATI-Docs",
  tracking: "Tracking",
  shipmentTracking: "GPS-tracking",
  insurance: "Insurance",
  ratingOfParticipants: "Rating",
  contacts: "Contacts",
  loans: "Loans",
  truckmarket: "Sale of transport",
  yourLoads: "Your loads",
  addLoad: "Add load",
  searchLoads: "Find loads",
  load: "load",
  yourTrucks: "Your trucks",
  addTruck: "Add truck",
  searchTrucks: "Find trucks",
  truck: "truck",
  orders: "Orders",
  ordersFromYou: "Orders from you",
  ordersToYou: "Orders to you",
  ordersToDriver: "Заявка водителю", // !
  vehicleFleet: "Vehicle Fleet",
  drivers: "Drivers",
  organizations: "Organizations",
  contractors: "Contractors & Contracts",
  boards: "Platforms",
  yourBoards: "Your platforms",
  invitationsAndApplications: "Invitations & applications",
  youParticipate: "You participate",
  invitations: "Invitations",
  aboutBoards: "About platforms",
  yourTenders: "Your Tenders",
  addTenders: "Add tender",
  catalogs: "Catalogs",
  directionsLists: "Lists of directions",
  companiesList: "List of companies ",
  requisites: "Your bank details",
  registration: "registration",
  toRegister: "registration",
  login: "Login",
  toLogin: "Login",
  code: "Code",
  copied: "copied",
  cars: "Cars",
  rating: "Rating",
  veh: "veh.",
  guaranteedPayment: "Guaranteed payment",
  remain: ["left", "left"],
  daysRemaining: ["day", "days"],
  paymentHaveToBeReceived: "Payment must be received before",
  paymentHadToBeReceived: "The payment should have been received before",
  expired: "expired",
  avatar: "Avatar",
  accountReplenishment: "Account replenishment",
  from: "from",
  rub: "rub",
  aMonth: "a mon",
  profile_freeAccessTooltip:
    "If you activate the license to view cars or cargo you would be able to:",
  viewContactsForCarsAndCargoes: "View contacts for cars and cargoes",
  viewPassports:
    "View passports of ATI.SU participants with reviews and claims",
  Common: "Common",
  yourContact: "Your contact",
  noLicenseInfo: "Licenses information is\xa0currently unavailable",
  shortMonths: {
    0: "jan.",
    1: "feb.",
    2: "mar.",
    3: "apr.",
    4: "may",
    5: "juny",
    6: "july",
    7: "aug.",
    8: "sen.",
    9: "oct.",
    10: "nov.",
    11: "dec.",
  },
  januaryGen: "January",
  februaryGen: "February",
  marchGen: "March",
  aprilGen: "April",
  mayGen: "May",
  juneGen: "June",
  julyGen: "July",
  augustGen: "August",
  septemberGen: "September",
  octoberGen: "October",
  novemberGen: "November",
  decemberGen: "December",

  year: "",

  recommendChangingBrowser: "We recommend changing your browser.",
  someSiteFeaturesMayNotWorkInThe: "Some site features may not work in the",
  thatYouAreUsing: "that you are using.",
  download: "Download",
  notificationsPluralize: {
    few: "new messages",
    many: "new messages",
    other: "new messages",
    one: "new message",
  },
  messagesPluralize: {
    few: "new messages",
    many: "new messages",
    other: "new messages",
    one: "new message",
  },
  remainPluralize: {
    one: "left",
    few: "left",
    many: "left",
    other: "left",
  },
  daysRemainingPluralize: {
    one: "day",
    few: "days",
    many: "days",
    other: "days",
  },
  contactsByLicense: {
    one: "add\u00A0contact",
    few: "add\u00A0contacts",
    many: "add\u00A0contacts",
    other: "add\u00A0contacts",
  },
  youHave: "You have",
  allRead: "All read",
  createBoard: "Create Board",
  unreadNotifications: "Unread notifications",
  noUnreadNotifications: "No unread notifications",
  notifications: "Notifications",
  atiMessenger: "ATI Messenger",
  viewUnread: "View unread",
  readAll: "Read all",
  viewAll: "View all",
  automaticPaymentEnabled: "Automatic Payment Enabled",
  clickBackAndTryAgain: "Click Back and try again.",
  back: "Back",
  sorrySomethingWentWrong: "Sorry, something went wrong.",
  loadingError: "Loading error.",
  addingNewLicensesWillBeAvailableAfterRenewal:
    "Adding new licenses will be available after renewal",
  searchParticipants: "Search Participants",
  stars: "Stars",
  refresh: "Refresh",
  loadsOnBoards: "Loads on platforms",
  sorrySomethingWentWrongPleaseTryAgain:
    "Sorry, something went wrong. Please try again",
  participantHasNoPaidLicenses: "Participant has no paid licenses",
  anErrorHasOccurredRefreshThePage: "An error has occurred, refresh the page",
  supportNGINX:
    "AutoTransInfo - one of the millions of services that use NGINX. Open-source technologies should be free.",
  browserIsNotOptimal:
    "Your browser is not optimal for working with ATI. Try another",
  weRecommend: "We recommend",
  or: "or",
  theSiteWillWorkMoreStable: "The site will work more stable",
  ICantUseAnotherBrowser: "I can't use another browser",
  howToInstallAnotherBrowser: "How to install another browser",
  tnxForVote: "Thanks for the vote",
  confirm: "Confirm",
  resend: "Resend",
  sendCode: "Send code",
  cancel: "Cancel",
  codeSent: "Code sent",
  codeSentOnNewEmail:
    "E-mail with a\xA0confirmation code was sent to\xA0the new e-mail address",
  resendAgain: "Send again after",
  seconds: "\xA0seconds.",
  youCan: "You can",
  unsubscribeFrom: "unsubscribe from the",
  turnPartnerOffers: "newsletter or\xA0turn off all partner offers",
  inNotificationSettings: "in\xA0the notification settings",
  youCanUnsubscribeFromPartners:
    "You can unsubscribe from the offers of\xA0ATI.SU partners {{inSettings}}",

  loanAvailable: "Available to you",
  cargoOwnerButtonAvailable: "ATI.SU с нуля",

  allServices: "All services",

  automationHeader: "Transportation automation",
  statisticHeader: "Statistics",
  securityHeader: "Security",
  comunicationHeader: "Communication",
  addInstrumentsHeader: "Additional tools",
  usefulHeader: "Useful information",

  apiLink: "API ATI.SU",
  apiLinkDescription: "Integrate your corporate software with ATI.SU services",
  automationLink: "Automation",
  gpsLink: "GPS monitoring",
  gpsDescription: "Track vehicle location and shipping status online",
  docsLink: "ATI-Docs (EDI)",
  docsDescription: "Create and exchange e-documents with partners",
  ordersLink: "Orders",
  ordersDescription:
    "Fully automate shipments from partner search to analytics",
  boardsLink: "Platforms ATI.SU",
  boardsDescription: "Create your own space for working with trusted partners",
  tendersLink: "Tenders",
  tendersDescription:
    "Sign long-term contracts for dozens and hundreds of shipments",
  auctionLink: "Bidding",
  auctionDescription: "Find the best price for your shipment",
  indexLink: "Index ATI.SU FTL Russia",
  indexDescription:
    "Dynamics of rates for the most popular directions in the Russian Federation",
  middlePriceLink: "Average rates",
  middlePriceDescription:
    "Current rates in RUB/km for thousands of destinations in Russia",
  cargoMapLink: "Load map",
  profitableDestinationsLink: "Profitable destinations",
  profitableDestinationsDesription: "",
  unlimitedCheckLink: "Unlimited verification of contractors",
  unlimitedCheckDescription:
    "Safety alert + report + extended analysis on companies from the Russian Federation",
  guaranteePaymentLink: "Guarantee of payment for transportation",
  guaranteePaymentDescription: "",
  checkLink: "ATI.SU Checks",
  checkShortLink: "Checks",
  checkDescription:
    "Check a legal entity, an individual or a vehicle to avoid losing goods or payment",
  trafficLightLink: "Traffic light+",
  trafficLightDescription:
    "Safety alert + report on companies from Russia and Kazakhstan",
  messengerLink: "ATI Messenger",
  messengerDescription:
    "Agree on shipping, send photos and documents to ATI.SU participant",
  forumsLink: "Forums",
  forumsDescription: "Discuss news, share experiences and opinions",
  realTruckLink: "Search for active carriers",
  realTruckDescription:
    "If it takes a long time to dispatch a shipment, find the right carrier",
  distanceCalculatorLink: "Distance calculation",
  distanceCalculatorDescription: "Plan a route for truck transport",
  chainsLink: "Freight consolidation",
  chainsDescription: "Select the most profitable chain with the maximum rate",
  academyLink: "ATI.SU Academy",
  academyDescription: "Learn how to effectively solve logistical problems",
  loansLink: "Loans",
  loansDescription: "Special conditions for ATI participants",
  newsLink: "News",
  newsDescription:
    "Be the first to know about the most important news in the world of freight transportation",
  partnershipLink: "Referral program",
  partnershipDescription: "Invite new participants and earn with us",
  ratingLink: "ATI.SU participant rating",
  ratingDescription: "Find the best participants in your area",
  insuranceLink: "Insurance",
  insuranceDescription: "Insure freight or liability in a few clicks",
  truckmarketLink: "Sale of transport",
  truckmarketDescription: "Sell, buy or rent vehicles and special equipment",
  timeSlots: "Time Slots",
  timeSlotsDescription:
    "Organize efficient warehouse operations without queues and fines",
  partnersOffers: "Special offers from partners",
  catalogsLink: "Catalogs",
  ticketsLink: "Appeals (tickets)",
  courierLink: "ATI Courier",

  loadsSearch: "Load search",
  mainMenu_loads: "Loads",
  trucksSearch: "Truck search",
  mainMenu_trucks: "Trucks",

  mainMenu_atiDocs_short: "ATI-Docs",

  cargoOwners: "For freight owners",

  submenu_codeCopied: "The code is copied",

  menu_section_loadsAndOrders: "Loads and Orders",
  menu_addLoad: "Add load",
  menu_yourLoads: "Your loads",
  menu_yourTenders: "Your Tenders",
  menu_addTenders: "Add tender",
  menu_yourOrders: "Orders from you",
  menu_reports: "Reports",
  menu_billing: "Pay for ATI.SU",

  menu_section_boards: "Platforms",
  menu_invitations: "Invitations",
  menu_yourBoards: "Your platforms",
  menu_youParticipate: "You participate",
  menu_createBoard: "Create platform",
  menu_boards: "Platforms",

  menu_section_carrierSearch: "Carrier search",
  menu_trucksSearch: "Find a vehicle",
  menu_activeCarriers: "Active carriers",
  menu_rating: "Rating of participants",
  menu_safetyMemo: "Safety memo",

  menu_section_catalogs: "Catalogs",
  menu_organizations: "Organizations",
  menu_partnersAndContracts: "Contractors & Contracts",
  menu_yourRequisites: "Your bank details",
  menu_firmLists: "List of companies",
  menu_directionLists: "Lists of destinations",
  menu_catalogs: "Your directories",
  menu_drivers: "Drivers",

  carriers: "For carriers",

  menu_section_trucksAndOrders: "Vehicles and Orders",
  menu_addTruck: "Add truck",
  menu_yourTrucks: "Your trucks",
  menu_ordersToYou: "Orders to you",

  menu_section_loadsSearch: "Load search",
  menu_loadsSearch: "Load search",
  menu_cargoChains: "Freight consolidation",
  menu_boardsSearch: "Platforms",

  menu_boardsLoadsSearch: "Loads on the Platforms",

  menu_section_trucksSearch: "Carrier search",
  menu_exchange: "Exchange ATI.SU",
  menu_gps: "GPS monitoring",

  menu_section_usefull: "Useful information",

  menu_section_yourDocuments: "Your documents",
  menu_section_rouming: "Roaming",
  menu_section_createDocument: "Create a document",
  menu_inbox: "Inbox",
  menu_awaitingDecision: "Pending",
  menu_closing: "Closing from ATI.SU",
  menu_yourCounterparties: "Your contractors",
  menu_yourCertificates: "Your electronic signature certificates",
  menu_invoice: "Payment invoice",
  menu_applicationAgreement: "Contract-application",
  menu_certificateOfCompletion: "Work completion certificate",
  menu_otherDocument: "Other document",

  menu_add_order: "Add an order",

  burger_addLoad: "Add load",
  burger_addTruck: "Add truck",

  bottom_yourLoad: "Your loads",
  bottom_loads: "Loads",
  bottom_yourTrucks: "Your trucks",
  bottom_trucks: "Trucks",
  bottom_services: "Services",
  bottom_orders: "Orders",
  bottom_profile: "Profile",

  mainMenu_atiDocs: "ATI-Docs (EDI)",

  profile_serviceUnavailable: "Service unavailable",
  profile_freeUser: "Free",
  profile_atis: "at.",
  profile_days: "days",
  profile_yourContact: "Your contact",
  profile_refresh: "Refresh",
  profile_score: "Balance",
  profile_room: "Account",
  profile_logout: "Logout",
  profile_freeAccess: "You have free access",
  profile_freeAccessText:
    "You can view only free trucks and loads. To see everything — buy a license.",
  profile_whatsMore: "What else gives a license?",
  profile_selectLicense: "Choose a license",
  profile_fromPerMonth: "from 460 ₽ per month",
  profile_payBefore: "Pay before {{val}}",
  profile_guaranteedPayment: "Guaranteed payment.",
  profile_remainPluralize: {
    one: "left",
    few: "left",
    many: "left",
    other: "left",
  },
  profile_daysRemainingPluralize: {
    one: "day",
    few: "days",
    many: "days",
    other: "days",
  },
  profile_conditions: "Terms",
  profile_pay: "Pay",
  profile_settings: "Settings",
  profile_automaticPaymentEnabled: "Automatic Payment Enabled",
  profile_paidFor: "Paid until {{val}}",
  profile_addingNewLicenses: "Adding new licenses",
  profile_WillBeAvailableAfterRenewal: "will be available after renewal",
  profile_add_new: "Add a license",
  profile_extend: "Extend",
  profile_add: "Upgrade",
  profile_recurrentPaymentFailed: "Не удалось списать автоплатёж",
  profile_code: "Code",

  search_participantsSearch: "Participants\xa0search",
  search_atiParticipantsSearch: "ATI.SU\xa0participants\xa0search",
  search_advancedSearch: "Advanced Search",
  search_advanced: "Advanced",
  search_phoneAndEmailRestriction:
    "Search by phone number and other contact information is available to paid users.",
  search_pricesAndRates: "Prices and tariffs",

  nps_recomendChance:
    "How likely would you recommend ATI.SU to someone you know?",
  nps_errorTryAgain:
    "Please try again. An error occurred while submitting the reply.",
  nps_rateNoRecommend: "I would never recommend it",
  nps_rateRecommend: "I would definitely recommend it",
  nps_thanksForRate: "Thank you for your reply ({{val}} from 10)",
  nps_commentYourAnswer: "Please comment on the answer",
  nps_send: "Send",
  nps_tryAgain: "Please try again.",
  nps_errorWhileSending: "An error occurred while submitting the reply.",
  nps_answerSended: "Response sent. Thank you for taking the survey",
  nps_youAlreadyVoted:
    "You have already voted. Thank you for taking the survey",

  security_header: "How safe do you think it is to work through ATI.SU?",
  security_rateNoRecommend: " totally unsafe",
  security_rateRecommend: "completely safe",
  security_headerSuccess: "Thank you for your reply",
  security_headerDescription:
    "If you have any comments, please feel free to share them",

  outdated_outdatedBrowserTitle: "Your browser may not work correctly",
  outdated_ieWasFound:
    "Your browser is outdated. For the ATI.SU Exchange to work without errors, please install one of the recommended browsers:",
  outdated_outdatedBrowserWasFound:
    "Your browser version is outdated. To work with ATI.SU Exchange without errors, please update your browser:",
  outdated_update: "Update",
  outdated_remindLater: "Remind me of this later",
  outdated_howToUpdate: "How to update your browser",
  outdated_howToInstallAnotherBrowser: "How to install a browser",

  refresh_attemptsLimitError:
    "Превышено кол-во обновлений, повторите через 5 минут", // !
  notification_unsubscribePartnerText:
    "You can {{val1}} or turn off all offers of our partners {{val2}}",
  notification_unsubscribePartnerATISU:
    "unsubscribe from the newsletter of this partner of ATI.SU",
  notification_notificationsSettings: "in the notification settings",

  feed_checkAll: "Mark all as read",
  feed_allRead: "All read",
  feed_showMessegesText: "Show the text of messenger messages",
  feed_groupedMessageCounter: {
    one: "message",
    few: "messages",
    many: "messages",
    other: "messages",
  },

  mainMenu_analitics: {
    statistika_rynka: "Market statistics",
    servisy_dlya_analitiki: "Analytic Tools",
    dinamika_rynka: "Market trends",
    rynok_v_cifrah: "Market in figures",
  },

  menu_analitics_averageRates: "Average rates",
  menu_analitics_cargomap: "Load map",
  menu_analitics_profitdirections: "Profitable destinations",
  menu_analitics_index: "Index",

  /** Это группе строк не нужен перевод */
  languageInformer_title: "Выберите язык интерфейса",
  languageInformer_description:
    "Вы всегда сможете изменить свой выбор в кабинете или подвале сайта.",
  languageInformer_button: "Сохранить",
  /** Конец группы */
};
